// `.env.ts` is generated by the `npm run env` command
// `npm run env` exposes environment variables as JSON for any usage you might
// want, like displaying the version or getting extra config from your CI bot, etc.
// This is useful for granularity you might need beyond just the environment.
// Note that as usual, any environment variables you expose through it will end up in your
// bundle, and you should not use it for any sensitive information like passwords or keys.
import { env } from './.env';

export const environment = {
  production: true,
  secure: true,
  version: env['npm_package_version'],
  apiUrl: `${window['env']?.serverUrl}/api`,
  memberUrl: window['env']?.memberUrl,
  serverUrl: window['env']?.serverUrl,
  backendBaseUrl: window['env']['backendBaseUrl'],
  environment: window['env']?.environment || 'development',
  defaultLanguage: 'de-DE',
  mobileBreakpoint: 768,
  supportedLanguages: ['de-DE', 'en-US', 'es-ES', 'fr-FR', 'it-IT', 'tr-TR'],
};
